import type { BaseCategoryRepository } from "#/Data/_Bases/BaseCategoryRepository.ts";
import BaseIndexedDBRepository from "#/Data/Implementations/BaseIndexedDBRepository.ts";
import type { LocalDatabaseCategory } from "../../../_Generated/Sync.gen";
import type { InternalIndexedDBDatabase } from "../../DataStores/Database";

export default class IndexedDBCategoryRepository extends BaseIndexedDBRepository<
    LocalDatabaseCategory
> implements BaseCategoryRepository {
    public readonly source: InternalIndexedDBDatabase["categories"];
    protected readonly dataTypeName = "Category";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.categories;
    }
    public search(value: string): Promise<Array<LocalDatabaseCategory>> {
        const needle = value.toLowerCase();

        return this.source
            .filter(classification => {
                return classification.name.toLowerCase().includes(needle);
            })
            .toArray();
    }
}
